var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDialerVisible
    ? _c(
        "div",
        { staticClass: "app-dialer-popup" },
        [
          _c("app-dialer-main-popup-container", {
            ref: "main-popup",
            attrs: {
              "is-info-active": _vm.isInfoActive,
              "is-keypad-active": _vm.isKeypadActive,
              "is-members-popup-active": _vm.isMembersPopupActive,
              "is-invite-popup-active": _vm.isInvitePopupActive,
              "is-transfer-popup-active": _vm.isTransferPopupActive,
            },
            on: {
              "toggle-info": function ($event) {
                return _vm.onTogglePopup("isInfoActive")
              },
              "toggle-keypad": function ($event) {
                return _vm.onTogglePopup("isKeypadActive")
              },
              "toggle-members-popup": function ($event) {
                return _vm.onTogglePopup("isMembersPopupActive")
              },
              "toggle-invite-popup": function ($event) {
                return _vm.onTogglePopup("isInvitePopupActive")
              },
              "toggle-transfer-popup": function ($event) {
                return _vm.onTogglePopup("isTransferPopupActive")
              },
            },
          }),
          _vm._v(" "),
          _vm.isKeypadActive
            ? _c("app-dialer-keypad-container", {
                ref: "keypad-popup",
                attrs: { component: "popup" },
                on: { close: _vm.onPopupClose },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isInfoActive
            ? _c("app-dialer-info-popup-container", {
                ref: "info-popup",
                on: { close: _vm.onPopupClose },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isMembersPopupActive
            ? _c("app-dialer-call-members-container", {
                ref: "members-popup",
                attrs: { component: "popup" },
                on: { close: _vm.onPopupClose },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isInvitePopupActive || _vm.isTransferPopupActive
            ? _c("app-dialer-actions-popup-container", {
                ref: "actions-popup",
                attrs: { "actions-type": _vm.actionsType },
                on: { close: _vm.onPopupClose },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }